export { default as dispatch } from "./dispatch.js";


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-dispatch@1.0.6@d3-dispatch/src/index.js
// module id = 460
// module chunks = 0